const slides = [
  {
    title: '2025娱乐圈塌房年鉴',
    desc: '盘点本年度最劲爆的明星塌房事件，从顶流到小生，谁也没能幸免。深度还原事件始末与后续发展。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20abstract%20red%20and%20dark%20composition%20with%20geometric%20shapes%20representing%20celebrity%20collapse%20scandals%2C%20warm%20crimson%20gradients%20with%20bold%20lighting%2C%20editorial%20design%20aesthetic%2C%20powerful%20visual%20impact%20with%20deep%20shadows&width=1000&height=600&seq=carousel-01-2026&orientation=landscape',
    tag: '年度专题',
    reads: '586万',
  },
  {
    title: '直播带货江湖：暴利背后的灰色产业链',
    desc: '起底直播带货行业不为人知的潜规则，从刷单到假货，从流量造假到售后黑洞。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dark%20amber%20and%20red%20visual%20with%20geometric%20grid%20patterns%20representing%20ecommerce%20industry%2C%20layered%20shapes%20with%20dramatic%20lighting%2C%20modern%20editorial%20investigative%20style%2C%20bold%20composition&width=1000&height=600&seq=carousel-02-2026&orientation=landscape',
    tag: '深度调查',
    reads: '412万',
  },
  {
    title: '选秀节目内定风波：谁在操控你的投票？',
    desc: '多位业内人士爆料选秀节目投票黑幕，粉丝花真金白银投的票，可能从未被计入。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20dramatic%20visual%20with%20warm%20red%20and%20gold%20geometric%20fragments%2C%20representing%20voting%20manipulation%20theme%2C%20layered%20composition%20with%20tension%20and%20mystery%2C%20modern%20editorial%20design&width=1000&height=600&seq=carousel-03-2026&orientation=landscape',
    tag: '独家揭秘',
    reads: '389万',
  },
  {
    title: '从素人到网红：流量背后的资本游戏',
    desc: '揭秘MCN机构如何批量制造网红，从人设打造到数据维护，每一环都是精心设计的生意。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20geometric%20visual%20with%20warm%20crimson%20and%20dark%20orange%20layered%20shapes%2C%20representing%20social%20media%20capital%20manipulation%2C%20dramatic%20lighting%2C%20modern%20editorial%20style&width=1000&height=600&seq=carousel-04-2026&orientation=landscape',
    tag: '资本解密',
    reads: '357万',
  },
  {
    title: '塌房之后：那些被封杀的艺人现在怎样了',
    desc: '追踪因各类丑闻被封杀的艺人现状，有人落魄无人问津，有人转战海外低调复出。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20melancholic%20visual%20with%20dark%20red%20and%20deep%20amber%20gradients%2C%20geometric%20falling%20shapes%20representing%20decline%2C%20atmospheric%20lighting%2C%20modern%20editorial%20documentary%20style&width=1000&height=600&seq=carousel-05-2026&orientation=landscape',
    tag: '后续追踪',
    reads: '298万',
  },
  {
    title: '数据不会说谎：十年爆料大数据报告',
    desc: '从海量爆料数据中提炼趋势，哪个行业最乱？什么类型的瓜最多？数据给你答案。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20infographic%20visual%20with%20warm%20red%20and%20amber%20geometric%20data%20elements%2C%20layered%20chart%20shapes%20and%20statistics%20patterns%2C%20modern%20editorial%20design%2C%20clean%20and%20bold%20composition&width=1000&height=600&seq=carousel-06-2026&orientation=landscape',
    tag: '数据分析',
    reads: '265万',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm text-primary-600 font-medium bg-primary-50 px-3 py-1 rounded-full">深度专题</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-2 text-sm text-foreground-500">全方位深度解读热点事件</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {slides.map((slide, index) => (
            <article key={index} className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-colors cursor-pointer group">
              <div className="relative aspect-[5/3] bg-background-200 overflow-hidden">
                <img
                  src={slide.image}
                  alt={slide.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 text-xs px-2.5 py-1 bg-primary-500/90 text-background-50 rounded-md whitespace-nowrap">{slide.tag}</span>
                <span className="absolute bottom-3 right-3 text-xs px-2 py-1 bg-black/60 text-background-50 rounded-md whitespace-nowrap"><i className="ri-eye-line mr-1"></i>{slide.reads}</span>
              </div>
              <div className="p-5">
                <h3 className="text-base font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">{slide.title}</h3>
                <p className="mt-2 text-xs text-foreground-500 leading-relaxed line-clamp-3">{slide.desc}</p>
                <div className="mt-4 flex items-center gap-2 text-xs text-primary-600 font-medium">
                  <span className="whitespace-nowrap">阅读全文</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}